module.exports = __webpack_public_path__ + "static/media/delete.662ebfae.svg";